export default function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="max-w-2xl mx-auto text-center bg-background-100 rounded-lg p-8 md:p-12">
          <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-accent-100 flex items-center justify-center">
            <i className="ri-mail-send-fill text-2xl text-accent-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto">
            如果您有影视资源投稿需求、合作意向或任何问题反馈，
            欢迎通过以下方式联系我们，我们会尽快回复您的消息。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line text-lg text-accent-500"></i>
              <span>contact@97cinema.com</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-wechat-line text-lg text-accent-500"></i>
              <span>微信公众号：97影院</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}